<div
  class="w-full h-full flex items-center justify-center overflow-hidden min-w-8 text-white"
  [style.background-color]="backgroundColor"
  [class.flex-row]="direction === 'horizontal'"
  [class.flex-col]="direction !== 'horizontal'"
>
  <span class="bm-loading bm-loading-spinner bm-loading-md"></span>
  @if (description) {
    <b class="m-2"> {{ description }} </b>
  }
</div>
